export default {
  BEZ_NAL_TYPE_0_NDS: 2,
  BEZ_NAL_TYPE_WITH_NDS: 1,
  BEZ_NAL_TYPE_WITHOUT_NDS: 3,
  SOFT_TYPE: 6,
  TOPLYVO_TYPE: 4,
  CASH_TYPE: 5
}
